import DashboardContainer from 'modules/general/containers/DashboardContainer';

const DashboardView = () => <DashboardContainer />;

export default DashboardView;
